import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalPurchaseSection() {
  return <section className="py-6 md:py-12 px-3 bg-brand-dark border-t border-white/5" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <div className="text-center mb-5" data-id="element-67">
          <div className="inline-block bg-brand-accent/20 text-brand-accent font-black px-4 py-1.5 rounded-full mb-3 border-2 border-brand-accent animate-pulse text-xs md:text-sm tracking-wide" data-id="element-68">
            ⏰ EL PRECIO CIERRA EN
          </div>
          <div className="mb-5" data-id="element-69">
            <CountdownTimer data-id="element-70" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-71">
          {/* Premium Kit */}
          <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-4 md:p-5 flex flex-col relative shadow-[0_0_20px_rgba(34,197,94,0.2)] order-1" data-id="element-72">
            <div className="absolute -top-3.5 left-1/2 transform -translate-x-1/2 bg-brand-accent text-white font-black px-4 py-1 rounded-full text-[10px] tracking-widest shadow-lg whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-73">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-3 mt-2" data-id="element-74">
              <h3 className="text-base md:text-lg font-black text-white mb-1 flex items-start" data-id="element-75">
                <span className="text-xl mr-2" data-id="element-76">🏆</span>
                <span data-id="element-77">KIT COMPLETO + UPSELL PREMIUM ⭐</span>
              </h3>
              <p className="text-brand-accent font-black text-sm" data-id="element-78">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="mb-4 flex-grow flex items-end" data-id="element-79">
              <div className="flex flex-col items-center w-full" data-id="element-80">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-81">
                  $63.000 ARS
                </span>
                <span className="text-3xl md:text-4xl font-black text-brand-accent neon-glow" data-id="element-82">
                  $27.950{' '}
                  <span className="text-base text-brand-accent/70" data-id="element-83">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47940575199470:1" className="py-3 md:py-4 text-sm md:text-lg w-full" pulse={true} data-id="element-84">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>

          {/* Basic Kit */}
          <div className="bg-brand-card rounded-xl border border-white/10 p-4 md:p-5 flex flex-col relative order-2" data-id="element-85">
            <div className="mb-3" data-id="element-86">
              <h3 className="text-base md:text-lg font-black text-white mb-1 flex items-center" data-id="element-87">
                <span className="text-xl mr-2" data-id="element-88">📘</span> KIT PROGRAMACIÓN
                TÉCNICA LISTA
              </h3>
              <p className="text-brand-accent font-black text-sm" data-id="element-89">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="mb-4 flex-grow flex items-end" data-id="element-90">
              <div className="flex flex-col items-center w-full" data-id="element-91">
                <span className="text-sm text-gray-500 line-through font-bold" data-id="element-92">
                  $45.000 ARS
                </span>
                <span className="text-3xl md:text-4xl font-black text-white" data-id="element-93">
                  $19.990 <span className="text-base text-gray-400" data-id="element-94">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47940574347502:1" className="py-3 text-sm md:text-base w-full" pulse={false} data-id="element-95">
              → QUIERO MI KIT AHORA
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-3 mt-6 text-[10px] md:text-xs text-gray-400 font-bold bg-brand-card py-3 rounded-lg border border-white/5" data-id="element-96">
          <div className="flex items-center" data-id="element-97">
            <Lock className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-98" />
            <span data-id="element-99">Pago seguro</span>
          </div>
          <div className="flex items-center" data-id="element-100">
            <Zap className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-101" />
            <span data-id="element-102">Acceso en 5 min</span>
          </div>
          <div className="flex items-center" data-id="element-103">
            <ShieldCheck className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-104" />
            <span data-id="element-105">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-106">
            <CreditCard className="w-3.5 h-3.5 mr-1 text-brand-accent" data-id="element-107" />
            <span data-id="element-108">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}